import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export const UFS_CURSO = [
  "Online", "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI",
  "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO",
];

export function UfCursoSelect({ value, onChange, testid }) {
  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger data-testid={testid}><SelectValue placeholder="Selecionar…" /></SelectTrigger>
      <SelectContent className="max-h-72">
        {UFS_CURSO.map((u) => <SelectItem key={u} value={u}>{u === "Online" ? "Online / EAD" : u}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
